const header = () => {
	const allOpenSubmenu = document.querySelectorAll('.js-arrow-submenu');
	const bars = document.querySelector('.s-header__bars');
	const exit = document.querySelector('.s-header__exit');
	const options = document.querySelectorAll('.c-menu-point');

	if (allOpenSubmenu) {
		allOpenSubmenu.forEach((arr) => {
			arr.addEventListener('click', (e) => {
				const targ = e.currentTarget;
				const parent = targ.parentElement;
				console.log(parent);
				console.log(arr);
				if (parent) {
					parent.classList.toggle('is-visible-submenu');
				}
			});
		});
	}
	if (bars) {
		// TODO: nadal menu (to białe pod pozycjami menu skacze)
		bars.addEventListener('click', () => {
			// TODO: coś namieszane z tymi klasami ale omówimy to, nie kasuj tego komentarza
			document.body.classList.add('show');
			if (options) {
				let i = 1;
				options.forEach((el) => {
					i += 1;
					el.classList.add(`c-menu-point--v${i}`);
				});
			}
		});
	}
	if (exit) {
		// TODO: jw. nie kasuj ale do naprawy
		exit.addEventListener('click', () => {
			document.body.classList.remove('show');
		});
	}

	// hide menu mobile when user scrolls
	window.addEventListener('scroll', (event) => {
		const body = document.querySelector('.cleantle-body');
		if (body.classList.contains('show')) body.classList.remove('show');
	});
};

export default header;
